import { render, staticRenderFns } from "./ModalEditarAssinatura.vue?vue&type=template&id=40b0fd2d&"
import script from "./ModalEditarAssinatura.vue?vue&type=script&lang=js&"
export * from "./ModalEditarAssinatura.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditarAssinatura.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports